<template>
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-2, -2)">
        <g transform="translate(2, 2)">
          <polygon id="Path" points="0 0 20 0 20 20 0 20"></polygon>
          <path
            id="Path"
            d="M10,8.33333333 C11.3807119,8.33333333 12.5,9.45262146 12.5,10.8333333 C12.5,12.2140452 11.3807119,13.3333333 10,13.3333333 C8.61928813,13.3333333 7.5,12.2140452 7.5,10.8333333 L7.50424391,10.6864393 C7.5802826,9.37409997 8.66859926,8.33333333 10,8.33333333 Z M10,10 C9.53976271,10 9.16666667,10.373096 9.16666667,10.8333333 C9.16666667,11.2935706 9.53976271,11.6666667 10,11.6666667 C10.4602373,11.6666667 10.8333333,11.2935706 10.8333333,10.8333333 C10.8333333,10.373096 10.4602373,10 10,10 Z"
            fill="currentColor"
            fill-rule="nonzero"
          ></path>
          <path
            id="Path"
            d="M11.6666667,14.1666667 C13.0473785,14.1666667 14.1666667,15.2859548 14.1666667,16.6666667 L14.1666667,17.5 C14.1666667,17.9602373 13.7935706,18.3333333 13.3333333,18.3333333 C12.873096,18.3333333 12.5,17.9602373 12.5,17.5 L12.5,16.6666667 C12.5,16.2064294 12.126904,15.8333333 11.6666667,15.8333333 L8.33333333,15.8333333 C7.87309604,15.8333333 7.5,16.2064294 7.5,16.6666667 L7.5,17.5 C7.5,17.9602373 7.12690396,18.3333333 6.66666667,18.3333333 C6.20642938,18.3333333 5.83333333,17.9602373 5.83333333,17.5 L5.83333333,16.6666667 C5.83333333,15.2859548 6.95262146,14.1666667 8.33333333,14.1666667 L11.6666667,14.1666667 Z"
            fill="currentColor"
            fill-rule="nonzero"
          ></path>
          <path
            id="Path"
            d="M14.1666667,1.66666667 C15.5473785,1.66666667 16.6666667,2.78595479 16.6666667,4.16666667 C16.6666667,5.54737854 15.5473785,6.66666667 14.1666667,6.66666667 C12.7859548,6.66666667 11.6666667,5.54737854 11.6666667,4.16666667 L11.6709106,4.01977268 C11.7469493,2.7074333 12.8352659,1.66666667 14.1666667,1.66666667 Z M14.1666667,3.33333333 C13.7064294,3.33333333 13.3333333,3.70642938 13.3333333,4.16666667 C13.3333333,4.62690396 13.7064294,5 14.1666667,5 C14.626904,5 15,4.62690396 15,4.16666667 C15,3.70642938 14.626904,3.33333333 14.1666667,3.33333333 Z"
            fill="currentColor"
            fill-rule="nonzero"
          ></path>
          <path
            id="Path"
            d="M15.8333333,7.5 C17.2140452,7.5 18.3333333,8.61928813 18.3333333,10 L18.3333333,10.8333333 C18.3333333,11.2935706 17.9602373,11.6666667 17.5,11.6666667 C17.0397627,11.6666667 16.6666667,11.2935706 16.6666667,10.8333333 L16.6666667,10 C16.6666667,9.53976271 16.2935706,9.16666667 15.8333333,9.16666667 L14.1666667,9.16666667 C13.7064294,9.16666667 13.3333333,8.79357062 13.3333333,8.33333333 C13.3333333,7.87309604 13.7064294,7.5 14.1666667,7.5 L15.8333333,7.5 Z"
            fill="currentColor"
            fill-rule="nonzero"
          ></path>
          <path
            id="Path"
            d="M5.83333333,1.66666667 C7.21404521,1.66666667 8.33333333,2.78595479 8.33333333,4.16666667 C8.33333333,5.54737854 7.21404521,6.66666667 5.83333333,6.66666667 C4.45262146,6.66666667 3.33333333,5.54737854 3.33333333,4.16666667 L3.33757724,4.01977268 C3.41361593,2.7074333 4.5019326,1.66666667 5.83333333,1.66666667 Z M5.83333333,3.33333333 C5.37309604,3.33333333 5,3.70642938 5,4.16666667 C5,4.62690396 5.37309604,5 5.83333333,5 C6.29357062,5 6.66666667,4.62690396 6.66666667,4.16666667 C6.66666667,3.70642938 6.29357062,3.33333333 5.83333333,3.33333333 Z"
            fill="currentColor"
            fill-rule="nonzero"
          ></path>
          <path
            id="Path"
            d="M5.83333333,7.5 C6.29357062,7.5 6.66666667,7.87309604 6.66666667,8.33333333 C6.66666667,8.79357062 6.29357062,9.16666667 5.83333333,9.16666667 L4.16666667,9.16666667 C3.70642938,9.16666667 3.33333333,9.53976271 3.33333333,10 L3.33333333,10.8333333 C3.33333333,11.2935706 2.96023729,11.6666667 2.5,11.6666667 C2.03976271,11.6666667 1.66666667,11.2935706 1.66666667,10.8333333 L1.66666667,10 C1.66666667,8.61928813 2.78595479,7.5 4.16666667,7.5 L5.83333333,7.5 Z"
            fill="currentColor"
            fill-rule="nonzero"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>
